import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import SelectField from '../../common/select_field';
import FilterPaper from '../../common/filter_paper';

const NotificationFilters = ({ podOption, onChangePod, podOptions, queryParams, onSearchInputChangeDebounced }) => {
    return (
        <FilterPaper title="Filtry notyfikacji">
            <Grid container spacing={ 3 } alignItems="flex-start">
                <Grid item xs={ 12 } md={ 6 }>
                    <SelectField
                        size="small"
                        fullWidth
                        label="Wybierz punkt sprzedaży (Pod)"
                        value={ podOption }
                        onChange={ onChangePod }
                        options={ podOptions }
                    />
                </Grid>
                <Grid item xs={ 12 } md={ 6 }>
                    <TextField
                        size="small"
                        fullWidth
                        label="Szukaj po tytule lub treści"
                        defaultValue={ queryParams?.query || '' }
                        onChange={ event => onSearchInputChangeDebounced(event.target.value) }
                        InputProps={ {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" color="action"/>
                                </InputAdornment>
                            ),
                        } }
                    />
                </Grid>
            </Grid>
        </FilterPaper>
    );
};

export default NotificationFilters;